import type { FeeRecord } from '../services/smr-admin';
import type { FeeReferenceData } from '../services/productFees';

type TransactionType = FeeReferenceData['transaction_types'][number];

export type PayerPair =
    | { status: 'derived'; paidById: string; paidToId: string }
    | { status: 'unrouted'; code: string }
    | { status: 'unknown' };

export function payerPairForFee(
    feeId: string,
    fees: Pick<FeeRecord, 'id' | 'transaction_type_id'>[],
    transactionTypes: Pick<TransactionType, 'id' | 'code' | 'paid_by_id' | 'paid_to_id'>[],
): PayerPair {
    const fee = fees.find((candidate) => candidate.id === feeId);
    const type = transactionTypes.find((candidate) => candidate.id === fee?.transaction_type_id);

    if (!type || type.paid_by_id === undefined || type.paid_to_id === undefined) {
        return { status: 'unknown' };
    }
    if (type.paid_by_id === null || type.paid_to_id === null) {
        return { status: 'unrouted', code: type.code };
    }
    return { status: 'derived', paidById: type.paid_by_id, paidToId: type.paid_to_id };
}
